<form (ngSubmit)="save()" [formGroup]="sourceForm">
	<div [alarisLoading]="sourcesService.loading$">
		<div class="edit-panel-header">
			<alaris-icon name="icon-add-contact"></alaris-icon>
			{{ source.SourceId ? ("sources.edit" | translate) : ("sources.add" | translate) }}
		</div>
		<div [alarisFade]="'vertical'" class="form-group panel-content">
			<alaris-tabs-button
				class="form-group_tabs-button_w-100"
				[bg]="'lighten'"
				[formControl]="sourceForm.controls.ConnectionType"
				[tabs]="connectionTypeTabs"
				size="xl"
			></alaris-tabs-button>

			<alaris-input formControlName="Name" [errors]="errors" [disabled]="!!source.SourceId">
				{{ "sources.name" | translate }}
			</alaris-input>

			<alaris-select2
				[alarisLoading]="providersService.loading$"
				[label]="'sources.type' | translate"
				formControlName="Type"
				[errors]="errors"
			>
				<alaris-select-filter2 [formControl]="providersFilter"></alaris-select-filter2>
				<alaris-options2
					*alarisVirtualFor="let provider of providers; let index"
					[value]="provider.name"
					[virtualIndex]="index"
				>
					{{ provider.name }}
				</alaris-options2>
			</alaris-select2>
			@for (
				group of providersService.map.get(sourceForm.controls.Type.value)?.groups ?? [];
				track group.name;
				let index = $index
			) {
				<h3>{{ "sources.groups." + group.name | translate }}</h3>
				@for (field of group.fields; track field.fieldName; let index = $index) {
					@if (getField(field, index).type === "checkbox") {
						<alaris-checkbox [formControl]="getControl(field)" [indeterminate]="false">
							{{ getField(field, index).name | translate }}
						</alaris-checkbox>
					} @else {
						@if (
							field.fieldName !== "ResponseCodeCacheList" &&
							field.fieldName !== "CacheSuccessfulResponseOnly" &&
							field.fieldName !== "MnpFieldType" &&
							field.fieldName !== "Port" &&
							field.fieldName !== "CurrencyName" &&
							field.fieldName !== "HuntStop"
						) {
							<alaris-filter-control
								[control]="getControl(field)"
								[field]="getField(field, index)"
								[alarisTooltip]="getExample(field)"
								[overflow]="false"
								[errors]="errors"
							></alaris-filter-control>
						}
						@if (field.fieldName === "CacheSuccessfulResponseOnly") {
							<alaris-tabs-button
								class="form-group_tabs-button_w-100"
								[bg]="'lighten'"
								[formControl]="getControl(field)"
								[tabs]="tabs"
								size="xl"
							></alaris-tabs-button>
						}
						@if (
							field.fieldName === "ResponseCodeCacheList" &&
							sourceForm.controls.CacheSuccessfulResponseOnly.value === 2
						) {
							<alaris-filter-control
								[control]="getControl(field)"
								[field]="getField(field, index)"
								[alarisTooltip]="getExample(field)"
								[overflow]="false"
								[errors]="errors"
							></alaris-filter-control>
						}
						@if (field.fieldName === "CurrencyName") {
							<alaris-select2
								[formControl]="getControl(field)"
								[alarisLoading]="providersService.loading$"
								[label]="'currencies.name' | translate"
								[errors]="errors"
								[alarisTooltip]="!source.SourceId ? ('sources.currency_tooltip' | translate) : ''"
								[disabled]="sourceForm.controls.SourceId.value !== null"
							>
								<alaris-select-filter2 [formControl]="currencyFilter"></alaris-select-filter2>
								<alaris-options2
									*alarisVirtualFor="let currency of currencies; let index"
									[value]="currency.Name"
									[virtualIndex]="index"
								>
									{{ currency.Name }}
								</alaris-options2>
							</alaris-select2>
						}
						@if (field.fieldName === "MnpFieldType") {
							<alaris-select2
								[formControl]="getControl(field)"
								[errors]="errors"
								[label]="'sources.fields.mnp_field_type' | translate"
							>
								<alaris-options2
									*alarisVirtualFor="let type of mnpFieldTypes; let index"
									[value]="type"
									[virtualIndex]="index"
								>
									{{ type }}
								</alaris-options2>
							</alaris-select2>
						}
						@if (field.fieldName === "Port") {
							<alaris-input-number
								[formControl]="getControl(field)"
								[label]="'sources.fields.port' | translate"
								[alarisTooltip]="getExample(field)"
								[overflow]="false"
								[errors]="errors"
								[thousandSeparator]="''"
							></alaris-input-number>
						}
						@if (field.fieldName === "HuntStop") {
							<alaris-select2
								[displayWith]="displayWithHuntstop.bind(this)"
								[formControl]="getControl(field)"
								[errors]="errors"
								[label]="'sources.fields.huntstop' | translate"
							>
								@let huntstopsFiltered = getHuntstopsFiltered();
								<alaris-options2
									*alarisVirtualFor="let h of huntstopsFiltered | keyvalue; let index"
									[value]="h.key"
									[virtualIndex]="index"
								>
									{{ h.value | translate }}
								</alaris-options2>
							</alaris-select2>
						}
					}
				}
			}
			<button (click)="reset()" alaris-button bType="secondary" class="reset-button" size="lg" type="button">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ "gl.reset" | translate }}
			</button>
		</div>
		<div class="edit-panel-footer">
			<button
				[disabled]="sourceForm.invalid || !sourceForm.dirty"
				alaris-button
				bType="primary"
				size="lg"
				type="submit"
			>
				<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
				{{ "gl.submit" | translate }}
			</button>
			<button (click)="close()" alaris-button bType="outline" size="lg" type="button">
				{{ "actions.close" | translate }}
			</button>
		</div>
	</div>
</form>
